import { sizes } from './constants';

export const convertMinSize = (stringSize, minSize) => {
  const numberSize = stringSize.match(/\d+/g);
  const sizeType = stringSize.match(/[a-zA-Z]+/g);

  if (sizeType && numberSize) {
    if (sizeType.length
        && sizes.includes(sizeType[0])
        && numberSize[0] !== ''
    ) {
      const intSize = parseInt(numberSize[0], 10);
      switch (sizeType[0]) {
        case 'Bytes':
          return intSize;
        case 'KB':
          return intSize * 1024 ** 1;
        case 'MB':
          return intSize * 1024 ** 2;
        case 'GB':
          return intSize * 1024 ** 3;
        default:
          return minSize;
      }
    } else {
      return minSize;
    }
  } else {
    return minSize;
  }
};

export const convertMaxSize = (stringSize, maxSize) => {
  const numberSize = stringSize.match(/\d+/g);
  const sizeType = stringSize.match(/[a-zA-Z]+/g);

  if (sizeType && numberSize) {
    if (sizeType.length
        && sizes.includes(sizeType[0])
        && numberSize[0] !== ''
    ) {
      const intSize = parseInt(numberSize[0], 10);
      switch (sizeType[0]) {
        case 'Bytes':
          return intSize;
        case 'KB':
          return intSize * 1024 ** 1;
        case 'MB':
          return intSize * 1024 ** 2;
        case 'GB':
          return intSize * 1024 ** 3;
        default:
          return maxSize;
      }
    } else {
      return maxSize;
    }
  } else {
    return maxSize;
  }
};

export const convertBytesTo = (bytes) => {
  if (bytes === 0) return '0 Byte';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  return `${Math.round(bytes / 1024 ** i, 2)} ${sizes[i]}`;
};
